import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { FieldGroup } from '../../../../../../models/application-requirements/application-requirements.interface';
import { toTitleCase } from '../../../../../../../shared/functions/strings';
import { SelectOption } from 'ng2-app/util/types/forms';
import { StatesService } from 'app/services/states/states.service';

@Component({
    selector: 'ba-address',
    templateUrl: 'address-attribute.component.html',
    styleUrls: ['address-attribute.component.scss']
})
export class AddressAttributeComponent implements OnInit, OnDestroy {

    @Input() field: FieldGroup;
    @Input() form: UntypedFormGroup;
    @Input() disabled: boolean;

    streetValue: string;
    street2Value: string;
    cityValue: string;
    stateValue: string;
    zipValue: string;

    streetAlias: string | null = '';
    street2Alias: string | null = '';
    cityAlias: string | null = '';
    stateAlias: string | null = '';
    zipAlias: string | null = '';

    streetAliases = ['owner_street_address', 'borrower.street'];
    street2Aliases = ['owner_street_address_', 'borrower.street2'];
    cityAliases = ['owner_city', 'borrower.city'];
    stateAliases = ['owner_state', 'borrower.stateId'];
    zipAliases = ['owner_zip', 'borrower.zipId'];

    stateOptions: SelectOption[];
    zipMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
    showStreet2 = false;

    private destroyed$ = new Subject<void>();

    constructor(private statesService: StatesService) {
        this.stateOptions = this.statesService.getAllStates().map((stateDesc) => {
            const titleCaseName = toTitleCase(stateDesc.label);
            return { label: titleCaseName, value: stateDesc.value };
        });
    }

    ngOnInit() {

        // Calculate aliases
        const streetField = this.group.fields.find(f => this.streetAliases.includes(f.alias));
        if (streetField) {
            this.streetValue = streetField.value;
            this.streetAlias = streetField.alias;
        }
        const street2Field = this.group.fields.find(f => this.street2Aliases.includes(f.alias));
        if (street2Field) {
            this.street2Value = street2Field.value;
            if (this.street2Value && this.street2Value.length > 0) {
                this.showStreet2 = true;
                this.street2Alias = street2Field.alias;
            }
        }
        const cityField = this.group.fields.find(f => this.cityAliases.includes(f.alias));
        if (cityField) {
            this.cityValue = cityField.value;
            this.cityAlias = cityField.alias;
        }
        const stateField = this.group.fields.find(f => this.stateAliases.includes(f.alias));
        if (stateField) {
            this.stateValue = this.stateLabel(stateField.value);
            this.stateAlias = stateField.alias;
        }
        const zipField = this.group.fields.find(f => this.zipAliases.includes(f.alias));
        if (zipField) {
            this.zipValue = zipField.value;
            this.zipAlias = zipField.alias;
        }
    }

    ngOnDestroy() {
        this.destroyed$.next();
    }

    stateLabel(stateValue: string): string {
        const option = this.stateOptions.find(o => o.value === stateValue);

        if (!option) {
            return '';
        }
        return option.label;
    }

    get group() {
        return this.field;
    }
}
